import type { CoreFetch } from '~/types/CoreFetch'
import type { Currency } from '~/types/currency'
import type { Plan } from '~/types/Subscription'

export function provideFetchPlanList(coreFetch: CoreFetch) {
  return () => coreFetch.$get<Plan[]>('/subscription/plans/')
}

export function provideSubscribePlan(coreFetch: CoreFetch) {
  return (planId: number) =>
    coreFetch.$post(`/subscription/plan/${planId}/subscribe/`)
}

export function provideFetchPlanCheckout(coreFetch: CoreFetch) {
  return ({
    planId,
    returnUrl,
    currency = 'EUR',
  }: {
    planId: number
    returnUrl: string
    currency?: Currency
  }) =>
    coreFetch.$post<{ client_secret: string | undefined }>(
      `/subscription/plan/${planId}/checkout/`,
      {
        return_url: returnUrl,
        currency,
      },
    )
}
